import logo from './logo.svg';
import './App.css';
import NavBar from './navbar';
import Footer from './footer';
import Home from './home';
import JoinUs from './joinUs';
import ContactUs from './contactUs';
import SupportUs from './supportUs';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import ImageCarousel from "./imageCarousel";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

function App() {
  return (
    <div className="App">
      <Router>
        <NavBar />
        <div className='mainContent'>
          <div className="main-title"></div>
            <h1 className="university">Lobo Powerlifting</h1>
            <h2 className="powerlifting">University of New Mexico</h2>
          <ImageCarousel />
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/join" element={<JoinUs />} />
            <Route path="/contact" element={<ContactUs />} />
            <Route path="/support" element={<SupportUs/>} />
          </Routes>
        </div>
        <Footer />
      </Router>
    </div>
  );
}

export default App;
